import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { DocsSection } from '@/components/common/docs-section';
import { docsClipsLinksIndex } from '@/config/links';
import { VideoObjectSchema } from './video-object-schema';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Clips Response Schema`}</h2>
    <p>{`The clip object is a variation of our publicly documented gif object. In addition to the properties provided by the gif object, clip objects have an additional video property that contains all of the media information for video format. The Pagination and Meta objects are also publicly documented.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`type`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates the type of GIPHY asset, always “video” for clips`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`id`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Unique ID for a GIPHY asset`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`url`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`URL linking to the `}<a parentName="td" {...{
              "href": "http://giphy.com/"
            }}>{`GIPHY - Be Animated`}</a>{` page for the clip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`embed_url`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`URL used to access a rich media player for the Clip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`username`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Username the Clip is attached to, if applicable`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`source`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The page on which this Clip was found`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`title`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The title that appears on `}<a parentName="td" {...{
              "href": "http://giphy.com/"
            }}>{`GIPHY - Be Animated`}</a>{` for the clip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`rating`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The MPAA-style rating for this content. Accepted values are G, PG, PG-13 and R`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`cta`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`CTA`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An optional object containing data for connections to third party applications for custom GIPHY partnerships when available for a Clip. For example, for this `}<a parentName="td" {...{
              "href": "https://giphy.com/gifs/migos-why-not-quavo-svsW4x2muqLGOrw0OY"
            }}>{`GIF`}</a>{` we link to a specific track within the Spotify app.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`images`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/api/schema#image-object"
            }}><inlineCode parentName="a">{`Image`}</inlineCode></a>{` `}{`[ ]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An object containing data for various available formats and sizes of this GIF version (i.e no sound) of Clip. Use any of these for previews in a scrollable grid. Check `}<a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/api/schema#image-object"
            }}>{`here`}</a>{` for more details. We do not generate the following renditions for Clips: preview, preview_gif, looping, fixed_width_small, fixed_width_small_still, fixed_height_small, fixed_height_small_still, downsized_small, downsized_still, downsized`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`user`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/api/schema#user-object"
            }}><inlineCode parentName="a">{`User`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An object containing data about the user associated with this clip, if applicable. Check `}<a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/api/schema#user-object"
            }}>{`here`}</a>{` for more details`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><strong parentName="td">{`video`}</strong></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/clips/schema#video-object"
            }}><inlineCode parentName="a">{`Video`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`An object that contains all of the media information for video format for the clip. Check `}<a parentName="td" {...{
              "href": "https:/developers.giphy.com/branch/master/docs/clips/schema#video-object"
            }}>{`here`}</a>{` for more details`}</td>
        </tr>
      </tbody>
    </table>
    <DocsSection anchorId={docsClipsLinksIndex.videoObjectSchema.hash} dividerLine={false} pathname={docsClipsLinksIndex.videoObjectSchema.pathname} mdxType="DocsSection">
      <VideoObjectSchema mdxType="VideoObjectSchema" />
    </DocsSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      